import { combineReducers } from '@reduxjs/toolkit';
import proposalsReducer from 'features/proposals/proposalsList/proposalsListSlice';
import postsReducer from 'features/posts/postsListSlice';
import postReducer from 'features/posts/postPreviewSlice';
import repliesReducer from 'features/posts/repliesSlice';
import proposalReducer from 'features/proposals/proposalDetails/proposalDetailsSlice';
import contentReducer from 'features/content/contentDetails/contentDetailsSlice';
import userReducer from 'features/user/userSlice'; 
import witnessesReducer from 'features/witnesses/witnessesSlice';

const rootReducer = combineReducers({
  proposals: proposalsReducer,
  proposal: proposalReducer,
  posts:postsReducer,
  post:postReducer,
  replies:repliesReducer,
  content: contentReducer,
  userData: userReducer, 
  witnesses: witnessesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
